import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

// Shared page chrome (sticky header + footer) for the home page and the
// signed-in pages (settings, events).
export default function Shell({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
}
